// authentication.service.ts
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CommonService } from "./../common.service";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class ProposalforHealthIciciElevate {
  constructor(private commonService: CommonService) {}

  private createPayload(): any {
    const savePayloads = "/payloads/addPayloads";
    const premiumData = JSON.parse(
      localStorage.getItem("icici_elevate_Premium_collection")
    );
    let kyc_response = JSON.parse(localStorage.getItem("KYC_Verified"));
    const proposal_Proposer = JSON.parse(
      localStorage.getItem("proposal_Proposer")
    );
    let proposal_nominee = JSON.parse(localStorage.getItem("proposal_nominee"));
    let proposal_insured_member = JSON.parse(
      localStorage.getItem("proposal_insured_member")
    );
    const insured_data = JSON.parse(
      localStorage.getItem("icici_elevate_quote_payload")
    );
    let insuredMember = [];
    let insuredTypes;

    proposal_insured_member.forEach((member) => {
      let dateOfBirth = `${member.date_of_birth.yy}-${member.date_of_birth.mm}-${member.date_of_birth.dd}`;
      //   let age = this.calculateAge(dateOfBirth);
      let pedList: string = null;
      if (member.selectedDiseaseIds && member.selectedDiseaseIds.length > 0) {
        pedList = member.selectedDiseaseIds.join(",");
      } else {
        pedList = null;
      }
      if (member.membertype.endsWith("a")) {
        insuredTypes = "Adult";
      } else if (member.membertype.endsWith("c")) {
        insuredTypes = "Kid";
      }
      if (member.selectedDiseaseIds && member.selectedDiseaseIds.length > 0) {
        pedList = member.selectedDiseaseIds.join(",");
      }
      let processedMember = {
        Name: `${member.first_name} ${member.middle_name} ${member.last_name}`,
        Gender: member.gender,
        IsPED: member.has_ped,
        PreExistingDiseaseCode: pedList,
        InsuredType: insuredTypes,
        RelationshipWithProposer: member.relationship_with_user
          .toUpperCase()
          .replace(/[_-]+/g, " ")
          .trim(),
        DateOfBirth: `${member.date_of_birth.dd.padStart(2, "0")}-${
          [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ][parseInt(member.date_of_birth.mm, 10) - 1]
        }-${member.date_of_birth.yy}`,
        Weight: member.weight,
        HeightsInFeets: member.height.ft,
        HeightsInInches: member.height.inch,
      };
      insuredMember.push(processedMember);
    });
    let appointeeData = {};
    if (
      proposal_Proposer.appointee &&
      proposal_Proposer.appointee.appointeeName &&
      proposal_Proposer.appointee.date_of_birth &&
      proposal_Proposer.appointee.appointeeRelationship
    ) {
      appointeeData = {
        AppointeeName: proposal_Proposer.appointee.appointeeName,
        AppointeeDOB: proposal_Proposer.appointee.date_of_birth,
        AppointeeRelationship:
          proposal_Proposer.appointee.appointeeRelationship.toUpperCase(),
      };
    }
    const payload = {
      RequestId: premiumData.correlationId,
      TransactionId: premiumData.transactionId,
      NomineeName: `${proposal_nominee.first_name} ${proposal_nominee.last_name}`,
      RelationshipWithInsured: proposal_nominee.relation_value.toUpperCase(),
      KYCRefNo: kyc_response.il_kyc_ref_no,
      ...appointeeData,
      SuccessUrl: `${environment.baseUrl}/icici-elevate-success`,
      FailureUrl: `${environment.baseUrl}/icici-elevate-success`,
      NomineeDOB: new Date(proposal_nominee.date_of_birth)
        .toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
        .replace(/ /g, "-"),

      Proposer: {
        EmailId: proposal_Proposer.emailId,
        MobileNo: proposal_Proposer.contactNumber,
        Name: `${proposal_Proposer.first_name} ${proposal_Proposer.middle_name} ${proposal_Proposer.last_name}`,
        DateOfBirth: `${proposal_Proposer.date_of_birth.dd.padStart(2, "0")}-${
          [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ][parseInt(proposal_Proposer.date_of_birth.mm, 10) - 1]
        }-${proposal_Proposer.date_of_birth.yy}`,
        AnnualIncome: proposal_Proposer.annual_income,
        PanCard: proposal_Proposer.pan,
        PinCode: proposal_Proposer.address.pincode,
        Gender: proposal_Proposer.gender,
      },

      Insured: insuredMember,
    };
    const proposalPayload = {
      g_id: localStorage.getItem("g_id"),
      transaction_id: payload.RequestId,
      user_id: localStorage.getItem("getquoteuserID"),
      proposal_payload: payload,
    };
    this.commonService
      .post(savePayloads, proposalPayload)
      .subscribe((prop) => {});
    return payload;
  }

  createProposal(): Observable<any> {
    const url = "/icici/proposal";

    const body = {
      payload: this.createPayload(),
    };
    return this.commonService.post(url, body);
  }
}
